import React from 'react';
import './style.css';
import { Button, Empty, Image, Input } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
const SkuSessionInfo = ({ skuSessionInfoData, handleSearch, handleBtnClick }) => {
    return (
        <div className="sku_info_main_wrapper">
            <div className="input_wrapper">
                <Input placeholder="Search barcode" onChange={e => handleSearch(e)} />
            </div>
            <div className="sku_session_info_container">
                {skuSessionInfoData.length > 0 ? (
                    skuSessionInfoData.map((sku, index) => {
                        const previewImg = sku.image.imagePath.url;
                        return (
                            <div className="card_wrapper">
                                <div className="card_image_wrapper">
                                    <Image
                                        src={sku.image.thumbPath.url}
                                        preview={{
                                            src: previewImg,
                                        }}
                                    />
                                </div>
                                <div className="card_status_wrapper">
                                    {sku.isRawQCComplete ? (
                                        <CheckCircleOutlined style={{ color: 'green', fontSize: '24px' }} />
                                    ) : (
                                        <ExclamationCircleOutlined style={{ color: 'orange', fontSize: '24px', marginLeft: '10px' }} />
                                    )}
                                </div>
                                <div className="card_info">
                                    <span>{sku.EAN}</span>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="empty_container">
                        <Empty />
                    </div>
                )}
            </div>
            <div className="button_wrapper">
                <Button type="primary" onClick={handleBtnClick}>
                    Close
                </Button>
            </div>
        </div>
    );
};
export default SkuSessionInfo;
